import { HTTP } from './http'

export const noProgramados = {
  asistencia (user) {
    return HTTP.post('noprogramados/getAsistencia', { user })
  },
  entrada (user, fecha, nombreImagen, timestamp, ubicacion, motivo, partner) {
    return HTTP.post('noprogramados/asistencia', { user, fecha, nombreImagen, timestamp, ubicacion, motivo, partner })
  },
  salida (user, nombreImagen, idNp) {
    return HTTP.post('noprogramados/SalidaNoProgramado', { user, nombreImagen, id_np: idNp })
  }
}
